import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { cancelQuotationThunk, resetDataCancelSolicitation } from "redux/Reducers/Concierge/cancelQuotationSlicer";

import { useForm } from "antd/es/form/Form";

import "Assets/styles/default/components/Concierge/Modals/CancelSolicitationModal.less"

import { Col, Form, Row, VertButton, VertInput, VertModal, VertTypography, notification } from "@vertem-core/vertice-ds";

const CancelSolicitationModal = (props) => {
  const { isOpen, setIsOpen, solicitationId, onSuccess } = props;

  const [note, setNote] = useState();

  const [ form ] = useForm();

  const dispatch = useDispatch();

  const {
    dataCancelSolicitation,
    loadingCancelSolicitation,
    errorCancelSolicitation,
  } = useSelector(
    (state) => state.CancelQuotationSolicitation
  );

  const validations = {
    note: {
      rules: [{
        required: true,
        message: "Campo obrigatório."
      }]
    }
  };

  const handleNoteChange = (value) => {
    setNote(value);
  }

  const handleSubmit = () => {
    form.validateFields().then(() => {
      const cancellation = {
        solicitationId,
        note,
      };

      dispatch(cancelQuotationThunk(cancellation));
    }).catch(() => {
      notification.error({
        message: "Preencha os campos corretamente.",
      });
    })
  }

  useEffect(() => {
    if (!dataCancelSolicitation) return;

    setIsOpen(false);

    notification.success({
      message: "Solicitação foi cancelada."
    });

    onSuccess();
  }, [dataCancelSolicitation]);

  useEffect(() => {
    if (!errorCancelSolicitation) return;

    notification.error({
      message: "Houve um erro ao cancelar solicitação, tente novamente."
    });

    dispatch(resetDataCancelSolicitation());
  }, [errorCancelSolicitation]);

  return (
    <VertModal
      className="concierge-cancel-modal"
      width={"50%"}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      destroyOnClose={true}
    >
      <Row>
        <Col>
          <VertTypography.Title>
            Você deseja cancelar esta solicitação?
          </VertTypography.Title>
        </Col>
      </Row>

      <Row>
        <Col>
          <VertTypography.Paragraph type="light">
            Ao confirmar esta ação, a solicitação será cancelada.
          </VertTypography.Paragraph>
        </Col>
      </Row>

      <Form form={form}>
        <Form.Item
          name="note"
          rules={validations.note.rules}
        >
          <VertInput.TextArea
            className="note"
            placeholder="Escreva o motivo do cancelamento"
            value={note}
            onChange={(e) => handleNoteChange(e.target.value)}
          /> 
        </Form.Item>
      </Form>

      <Row className="actions" justify="end">
        <Col className="action-btn-group">
          <VertButton
            className="button-concierge"
            onClick={() => setIsOpen(false)}
          >
            Fechar
          </VertButton>

          <VertButton
            className="btn-confirm"
            type="highlight"
            loading={loadingCancelSolicitation}
            onClick={handleSubmit}
          >
            Confirmar
          </VertButton>
        </Col>
      </Row>
    </VertModal>
  )
}

export default CancelSolicitationModal;